import React, { useState, useEffect } from "react";
import axios from "axios";
import { MdLocalPhone, MdOutlineEmail } from "react-icons/md";
import chnage_password from "../../assets/img/chnage_password.png";
import bg_white from "../../assets/img/login-Logo.png";
import Footer from "../Footer/Footer";
import { useNavigate } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import { useTranslation } from "react-i18next";
import NoCopyWrapper from "../../utils/NoCopyWrapper";
import NoZoomWrapper from "../../utils/NoZoomWrapper";
const Password = () => {
  const [step, setStep] = useState(1);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [countdown, setCountdown] = useState(300);
  const [user, setUser] = useState(null);
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) setUser(JSON.parse(storedUser));
  }, []);

  const handleSendOTP = async () => {
    try {
      if (selectedMethod === user?.email) {
        await axios.post("https://network.rentel.in/email/send-email", {
          email: selectedMethod,
        });
      } else if (selectedMethod === user?.phoneNumber) {
        await axios.post("https://network.rentel.in/via-whatsapp/send-otp", {
          phoneNumber: selectedMethod,
        });
      }
      setStep(2);
      setCountdown(300);
      setError("");
    } catch {
      setError("Failed to send OTP. Please try again.");
    }
  };

  const handleVerifyOTP = async () => {
    const otpCode = otp.join("");
    if (otpCode.length !== 6) return setError("Please enter the 6-digit OTP.");
    try {
      const url =
        selectedMethod === user?.email
          ? "https://network.rentel.in/email/verify-otp"
          : "https://network.rentel.in/via-whatsapp/verify-otp";
      const payload =
        selectedMethod === user?.email
          ? { email: selectedMethod, otp: otpCode }
          : { phoneNumber: selectedMethod, otp: otpCode };
      const res = await axios.post(url, payload);
      if (res?.data?.message === "OTP verified successfully") {
        setStep(3);
        setError("");
      } else setError(res?.data?.message || "Invalid OTP. Please try again.");
    } catch (err) {
      setError(
        err?.response?.data?.message ||
          "OTP verification failed. Please try again."
      );
    }
  };

  const handleResetPassword = async () => {
    if (password !== confirmPassword)
      return setError("Passwords do not match.");
    if (password.length < 8)
      return setError("Password must be at least 8 characters.");
    try {
      const payload = { newPassword: password, otp: otp.join("") };
      selectedMethod === user?.email
        ? (payload.email = user.email)
        : (payload.phoneNumber = user.phoneNumber);
      await axios.put(
        "https://network.rentel.in/users/change-password",
        payload
      );
      alert("Password successfully reset!");
      navigate("/login");
      setStep(1);
      setOtp(["", "", "", "", "", ""]);
      setPassword("");
      setConfirmPassword("");
      setSelectedMethod("");
    } catch {
      setError("Error resetting password. Please try again.");
    }
  };

  const handleOtpInput = (value, index) => {
    if (!/^\d*$/.test(value)) return;
    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);
    if (value && index < 5) document.getElementById(`otp-${index + 1}`).focus();
  };

  useEffect(() => {
    if (step === 2 && countdown > 0) {
      const timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [step, countdown]);

  return (
    <>
      <NoZoomWrapper>
        <NoCopyWrapper>
          <div className="change-password-header">
            <IoIosArrowBack
              size={24}
              className="back-arrow"
              onClick={() => navigate(-1)}
            />
            <span className="header-title">Change password</span>
          </div>

          <div className="container">
            <div className="change-password-container">
              <img
                className="change-pass"
                src={chnage_password}
                alt="Change Password"
              />
              <p className="change-pass-text">
                {t("reset_password_instruction")}
              </p>
            </div>

            <div className="reset-container">
              {step === 1 && (
                <div>
                  <h2>Change Password</h2>
                  <p>Select a contact method:</p>
                  <div className="contact-methods">
                    <div
                      className={`option ${
                        selectedMethod === user?.email ? "active" : ""
                      }`}
                      onClick={() => setSelectedMethod(user?.email)}
                    >
                      <div className="icon-circle">
                        <MdOutlineEmail size={24} color="#e91e63" />
                      </div>
                      <div>
                        <p className="via-email">{t("viaEmail")} :</p>
                        <p className="via-email">{user?.email || ""}</p>
                      </div>
                    </div>
                    <div
                      className={`option ${
                        selectedMethod === user?.phoneNumber ? "active" : ""
                      }`}
                      onClick={() => setSelectedMethod(user?.phoneNumber)}
                    >
                      <div className="icon-circle">
                        <MdLocalPhone size={24} color="#e91e63" />
                      </div>
                      <div>
                        <p className="via-phone">{t("viaPhoneNumber")} :</p>
                        <p className="via-phone">
                          +91 {user?.phoneNumber || ""}
                        </p>
                      </div>
                    </div>
                  </div>
                  <button
                    className="next-btn"
                    onClick={handleSendOTP}
                    disabled={!selectedMethod}
                  >
                    {t("continue")}
                  </button>
                  {error && <p className="error">{error}</p>}
                </div>
              )}

              {step === 2 && (
                <div>
                  <h2>OTP {t("otpVerification")}</h2>
                  <p>
                    {t("enterCodeSentTo")} <strong>{selectedMethod}</strong>
                  </p>
                  <div className="otp-inputs">
                    {otp.map((digit, index) => (
                      <input
                        key={index}
                        id={`otp-${index}`}
                        type="text"
                        maxLength="1"
                        value={digit}
                        onChange={(e) => handleOtpInput(e.target.value, index)}
                      />
                    ))}
                  </div>
                  <p>
                    {t("resendCodeIn")}{" "}
                    <span className="countdowne">
                      {Math.floor(countdown / 60)}:
                      {String(countdown % 60).padStart(2, "0")}
                    </span>
                  </p>
                  <button className="next-btn" onClick={handleVerifyOTP}>
                    {t("confirm")}
                  </button>
                  {error && <p className="error">{error}</p>}
                </div>
              )}

              {step === 3 && (
                <div>
                  <img className="bg_img" src={bg_white} alt="Reset Password" />
                  <h2>{t("createNewPassword")}</h2>
                  <input
                    className="pass-imp"
                    type="password"
                    placeholder={t("newPasswordPlaceholder")}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                  <input
                    className="pass-imp"
                    type="password"
                    placeholder={t("confirmPasswordPlaceholder")}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                  <button className="reset-pass" onClick={handleResetPassword}>
                    {t("resetPassword")}
                  </button>
                  {error && <p className="error">{error}</p>}
                </div>
              )}
            </div>
          </div>
          <Footer />
        </NoCopyWrapper>
      </NoZoomWrapper>
    </>
  );
};

export default Password;
